"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const dateformat_1 = require("../../../common/js/helper/dateformat");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const UiStore_1 = __importDefault(require("../../stores/UiStore"));
const Greetings = () => (react_1.default.createElement("div", { className: "znd-dashboard-page__greeting" },
    react_1.default.createElement("h1", { className: "znd-dashboard-page__title t-headline-2" }, (0, translation_1.t)('dashboard.greetings.message', {
        type: null !== AuthorizationStore_1.default.user ? 'user' : null,
        name: AuthorizationStore_1.default.contactName,
    })),
    react_1.default.createElement("span", { className: "znd-dashboard-page__datetime" }, (0, dateformat_1.getDateFormat)(UiStore_1.default.sixtySeconds, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        dateStyle: undefined,
    }))));
exports.default = (0, mobx_react_1.observer)(Greetings);
